import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import {
	AUTH_TOKEN,
	SIGNIN,
	SIGNOUT,
	SIGNUP,
	SIGNIN_WITH_GOOGLE,
	SIGNIN_WITH_FACEBOOK,
	AUTHENTICATED,
} from "../constants/Auth";
import {
	showAuthMessage,
	authenticated,
	signOutSuccess,
	signUpSuccess,
	signInWithGoogleAuthenticated,
	signInWithFacebookAuthenticated,
} from "../actions/Auth";

import MenuService from "services/MenuService";

export function* signIn() {
	yield takeEvery(AUTHENTICATED, function* (payload) {
		localStorage.setItem(AUTH_TOKEN, payload.token);
		MenuService.clearStoredTenant();
	});
}

export function* signInWithFBEmail() {
	yield takeEvery(SIGNIN, function* ({ payload }) {
		yield put(showAuthMessage("Autenticação por Firebase desabilitada."));
	});
}

export function* signOut() {
	yield takeEvery(SIGNOUT, function* () {
		try {
			localStorage.removeItem(AUTH_TOKEN);
			MenuService.clearStoredTenant();
			yield put(signOutSuccess());
		} catch (err) {
			yield put(showAuthMessage(err));
		}
	});
}

export function* signUpWithFBEmail() {
	yield takeEvery(SIGNUP, function* ({ payload }) {
		yield put(showAuthMessage("Cadastro via Firebase desabilitado."));
	});
}

export function* signInWithFBGoogle() {
	yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
		yield put(showAuthMessage("Login com Google desabilitado."));
	});
}

export function* signInWithFacebook() {
	yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
		yield put(showAuthMessage("Login com Facebook desabilitado."));
	});
}

export default function* rootSaga() {
	yield all([
		fork(signIn),
		fork(signInWithFBEmail),
		fork(signOut),
		fork(signUpWithFBEmail),
		fork(signInWithFBGoogle),
		fork(signInWithFacebook),
	]);
}
